import logoSrc from '/images/Logo.png';

export function GHLogo({ scale = 1 }) {
  return (
    <div style={{
      height: Math.round(64 * scale) + 'px',
      display: 'flex', alignItems: 'center',
      background: '#232326', borderRadius: 4, overflow: 'hidden',
      padding: `0 ${Math.round(4 * scale)}px`,
    }}>
      <img
        src={logoSrc}
        alt="GreyHolm Group"
        style={{ height: Math.round(56 * scale) + 'px', width: 'auto', display: 'block' }}
      />
    </div>
  );
}
